export const makeExternalFormSubmit = formId => () =>
  console.log(document.getElementById(formId)) ||
  // { cancelable: true } required for Firefox
  // https://github.com/facebook/react/issues/12639#issuecomment-382519193
  document
    .getElementById(formId)
    .dispatchEvent(new Event("submit", { cancelable: true }));
